module.exports = __webpack_public_path__ + "static/media/tango-deco.5581dbe5.png";